(() => {
  'use strict';

  const selector = '[data-xifun-explore-switcher]';
  const controllers = new Map();

  class XifunExploreSwitcher {
    constructor(section) {
      this.section = section;
      this.tabs = [...section.querySelectorAll('[data-xifun-explore-tab]')];
      this.panels = [...section.querySelectorAll('[data-xifun-explore-panel]')];
      this.status = section.querySelector('[data-xifun-explore-status]');
      this.onClick = this.handleClick.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
    }

    init() {
      if (!this.tabs.length || this.section.dataset.xifunInitialized === 'true') return;
      this.section.dataset.xifunInitialized = 'true';
      this.section.classList.add('is-enhanced');
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.onClick);
        tab.addEventListener('keydown', this.onKeydown);
      });
      this.activate(0, false);
    }

    handleClick(event) {
      this.activate(Number(event.currentTarget.dataset.xifunExploreTab), true);
    }

    handleKeydown(event) {
      const current = Number(event.currentTarget.dataset.xifunExploreTab);
      if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      let next = current;
      if (event.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
      if (event.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = this.tabs.length - 1;
      this.activate(next, true);
      this.tabs[next].focus();
    }

    activate(index, announce) {
      const safeIndex = Math.max(0, Math.min(index, this.tabs.length - 1));
      this.tabs.forEach((tab, tabIndex) => {
        const active = tabIndex === safeIndex;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
      });
      this.panels.forEach((panel, panelIndex) => {
        const active = panelIndex === safeIndex;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (announce && this.status) {
        const label = this.tabs[safeIndex].lastElementChild?.textContent.trim()
          || this.tabs[safeIndex].textContent.trim();
        this.status.textContent = `目前顯示${label}。`;
      }
      this.section.dispatchEvent(new CustomEvent('xifun:tracking', {
        bubbles: true,
        detail: { event: 'explore_mode_selected', index: safeIndex }
      }));
    }

    destroy() {
      this.tabs.forEach((tab) => {
        tab.removeEventListener('click', this.onClick);
        tab.removeEventListener('keydown', this.onKeydown);
      });
      this.panels.forEach((panel) => { panel.hidden = false; });
      this.section.classList.remove('is-enhanced');
      delete this.section.dataset.xifunInitialized;
      controllers.delete(this.section);
    }
  }

  const init = (scope = document) => {
    const sections = scope.matches?.(selector) ? [scope] : [...scope.querySelectorAll(selector)];
    sections.forEach((section) => {
      if (controllers.has(section)) return;
      const controller = new XifunExploreSwitcher(section);
      controllers.set(section, controller);
      controller.init();
    });
  };

  if (!window.__xifunExploreSwitcherLoaded) {
    window.__xifunExploreSwitcherLoaded = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
    document.addEventListener('shopify:section:unload', (event) => controllers.get(event.target)?.destroy());
    window.addEventListener('pageshow', () => init());
  }

  init();
})();
